<template>
  <div class="contanctus">
    <div class="CU-info">
      <div class="intro">
        HELLO,
        <br />WE ARE READY TO BE
        <br />WITH YOU
      </div>
      <div class="office-info">
        <div class="icon">
          <Phone :size="24" fillColor="#00a79d" />
        </div>
        <div class="font">070-8873-8126</div>
      </div>
      <div class="office-info">
        <div class="icon">
          <Email :size="24" fillColor="#00a79d" />
        </div>
        <div class="font">hello@wustone.com</div>
      </div>
      <div class="office-info">
        <div class="icon">
          <MapMarker :size="24" fillColor="#00a79d" />
        </div>
        <div class="font">서울특별시 강서구 마곡중앙2로 11 W타워 3차 410호</div>
      </div>
      <hr />
      <div class="office-time">고객센터 업무시간: 평일 오전 9:30 ~ 저녁 7:00 점심시간: 11:30 ~ 12:30 공휴일 휴무</div>
    </div>
    <div class="CU-map">
      <GmapMap
        :center="{lat:37.5581852 , lng:126.8260064}"
        :zoom="16"
        :map-type-id="terrain"
        style="width:100%; height:800px;"
      ></GmapMap>
    </div>
  </div>
</template>
<script>
import Phone from "vue-material-design-icons/Phone";
import Email from "vue-material-design-icons/Email";
import MapMarker from "vue-material-design-icons/MapMarker";
export default {
  name: "ContactUs",
  components: {
    Phone,
    Email,
    MapMarker
  }
};
</script>
<style lang="scss" scoped>
.contanctus {
  min-width: 1400px;
  height: 100%;
  padding-top: 80px;
  box-sizing: border-box;
  // background-color: #f3fffd;
  position: relative;

  .CU-info {
    width: 100%;
    padding: 80px 120px 80px 120px;
    box-sizing: border-box;

    .intro {
      font-size: 7vh;
      font-weight: 900;
      margin-bottom: 100px;
      color: #00a79d;
      text-shadow: 0 13.36px 8.896px #cadedc, 0 -2px 1px #ffffff;
      letter-spacing: 2px;
    }

    .office-info {
      display: flex;
      flex-direction: row;
      margin-bottom: 20px;

      .font {
        font-size: 2vh;
        color: #6d6d6d;
        margin-left: 10px;
      }
    }

    .office-time {
      font-size: 2vh;
      color: #6d6d6d;
      margin-top: 20px;
    }
  }
}
</style>